import React, { FC, useState } from 'react'

import Heading from '../../../../../../uiKit/texts/Heading'
import { Storage } from '@material-ui/icons'
import TextForm from '../../../../components/TextForm'
import TabTile from '../../../../components/TabTile'
import { useDatasetTables } from '../../hooks/useDatasetTables'
import Loader from 'uiKit/loaders/loader'
import { DescriptionDatasetMetrics } from './DescriptionDatasetMetrics'
import { GetTableListResponse } from '../../../../api/generated'
import DescriptionDatasetTablesHeader from './DescriptionDatasetTablesHeader'
import { Highlighted } from '../../../../components/Highlighted'

type DescriptionDatasetTablesProps = {
  datasetId?: string
}

export const DescriptionDatasetTables: FC<DescriptionDatasetTablesProps> = ({ datasetId }) => {
  const { data = [], loading } = useDatasetTables(datasetId)

  const [expandedTable, setExpandedTable] = useState('')
  const [search, setSearch] = useState('')

  let displayTables: GetTableListResponse['tables'] = data
  if (search) {
    displayTables = data.filter(({ tableName, tableDescription, metrics }) => {
      const searchValue = search.toLowerCase()
      return (
        tableName.toLowerCase().includes(searchValue) ||
        tableDescription.toLowerCase().includes(searchValue) ||
        metrics.join('|||| ').toLowerCase().includes(searchValue)
      )
    })
  }

  const handleChangeExpandedDataset = (tableId: string) => {
    const nextValue = expandedTable !== tableId ? tableId : ''
    setExpandedTable(nextValue)
  }

  return (
    <div style={{ paddingTop: 16 }}>
      {/* @ts-ignore*/}
      <DescriptionDatasetTablesHeader search={search} onChange={setSearch} count={data?.length} />

      {!displayTables.length && loading && (
        <div style={{ margin: '40px auto' }}>
          <Loader />
        </div>
      )}

      {displayTables.map((item, index) => (
        <TabTile
          key={index}
          expanded={expandedTable === item.tableId}
          tab={{
            name: <Highlighted text={item.tableName} highlight={search} />,
            icon: <Storage fill={'var(--bs-gray-600)!important'} />,
            description: `${item?.metrics?.length || 0} metrics`,
          }}
          onChange={() => handleChangeExpandedDataset(item.tableId)}>
          <div>
            <TextForm
              isFromEdit
              updatedAt={item?.updatedAt}
              submitButtonLabel="Save table changes"
              inputDescription="Table information"
              inputText={item.tableName}
              textAreaContent={item.tableDescription}
              onClick={async (t, textTitle) => {
                console.log('')
              }}
            />

            <Heading>
              <small>
                {item.tableName} Metrics <small>({item?.metrics.length || 0})</small>
              </small>
            </Heading>

            <DescriptionDatasetMetrics metrics={item?.metrics} search={search} />
          </div>
        </TabTile>
      ))}
    </div>
  )
}
